import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const normalzoneApi = createApi({
    reducerPath: "/core/normal/zone",
    baseQuery: axiosBaseQuery,
    tagTypes: ["normalzone"],
    endpoints: (builder) => ({
        normalzoneFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['normalzone'],
            query: (query = '') => ({
                url: "/core/normal/zone" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        normalzoneCreate: builder.mutation({
            invalidatesTags: ['normalzone'],
            query: (data) => ({
                url: `/core/normal/zone`,
                method: "POST",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        }),
        normalzoneUpdate: builder.mutation({
            invalidatesTags: (result, error, data) => [
                'normalzone',
                { type: 'normalzone', id: data.get('id') },
            ],
            query: (data) => ({
                url: `/core/normal/zone/${data.get('id')}`,
                method: "PUT",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                } 
            })
        }),

        normalzoneDelete: builder.mutation({
            invalidatesTags: ['normalzone'],
            query: (id) => ({ url: "/core/normal/zone/" + id, method: "DELETE" })
        }),
        normalzoneFindOne: builder.query<{ data: {} }, any | void>({
            providesTags: (result, error, id) => [{ type: 'normalzone', id }],
            query: (id: any) => ({
              url: "/core/normal/zone/" + id,
              method: "GET",
            }),
            transformResponse: (response: any) => {
              return {
                data: response.data,
              };
            },
          }),
    })
})

export const { useNormalzoneFindAllQuery, useNormalzoneCreateMutation, useNormalzoneUpdateMutation, useNormalzoneDeleteMutation , useNormalzoneFindOneQuery} = normalzoneApi;
export { normalzoneApi };
